import React, { useState, useRef } from 'react'
import { gsap } from 'gsap'
import className from 'classnames'
import { Link } from "gatsby"
import { useIntl } from 'react-intl'
import style from './index.module.less'
import useNavigateLink from "@/hooks/useNavigateLink"
import getCountry from '@/utils/getCountry.js'
import { REGION_TO_FOOTER_MAP } from '@/data/newfooter.js'
import ArrowDown from "@/images/SVG/arrow-down-w.svg"


const NewFooterListMobile = () => {
  const intl = useIntl()
  const region = getCountry()
  const footer_list_arr = REGION_TO_FOOTER_MAP[region] || REGION_TO_FOOTER_MAP.default
  const navigateLink = useNavigateLink
  const [showSubListBox, setShowSubListBox] = useState(null)
  const subBoxRef = useRef([])

  const toggleSubBox = (index) => {
    if (showSubListBox === index) {
      gsap.to(subBoxRef.current[index], {
        height: 0,
        opacity: 0,
        duration: 0.3,
        onComplete: () => setShowSubListBox(null),
      });
    } else {
      const targetHeight = subBoxRef.current[index].scrollHeight;
      setShowSubListBox(index);
      gsap.fromTo(
        subBoxRef.current[index],
        { height: 0, opacity: 0 },
        { height: targetHeight, opacity: 1, duration: 0.3, onComplete: () => {
          subBoxRef.current[index].style.height = 'auto';
        }}
      );
    }
  };


  const getLinkUrl = (link) => {
    const url = navigateLink(link)
    return url
  }

  return (
    <div className={style.footerlistMobile}>
      {
        footer_list_arr.map((item, index) => (
          <div className={style.footerListItemM} key={`footer-m-${item.title}`}>
            <div
              className={className(style.footerListItemMTitle, showSubListBox == index ? style.titleBottom : '')}
              onClick={() => toggleSubBox(index)}
            >
              <div>{intl.formatMessage({ id: item.title })}</div>
              <ArrowDown className={className(style.titleIcon, showSubListBox == index ? style.arrowUp : '')} />
            </div>
            <div 
              ref={(el) => (subBoxRef.current[index] = el)}
              className={style.footerListItemMSubbox}
              style={{ height: showSubListBox !== index ? '0' : ''}}
            >
              {
                item.list.map(value => (
                  value.outlink ? 
                    <a href={value.link} target='_blank' className={style.subItem} key={value.name}>
                        {value.translate ? intl.formatMessage({ id: value.name }) : value.name} 
                    </a> : <Link to={getLinkUrl(value.link)} className={style.subItem} key={value.name}>
                        {value.translate ? intl.formatMessage({ id: value.name }) : value.name}
                    </Link>
                ))
              }
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default NewFooterListMobile